import { VehicleCategoryFeatureItemTypeEnum } from '../../../shared/modules/vehicle-category-feature-items/enums/vehicle-category-feature-item-type.enum';
import { VehicleFeatureItemTypeEnum } from '../../../shared/modules/vehicle-feature-items/enums/vehicle-feature-item-type.enum';
import { TenantFeatureItemTypeEnum } from '../../../tenant/tenant-feature-items/enums/tenant-feature-item-type.enum';

/**
 * Asset feature item type values
 */
export enum AssetFeatureItemTypeEnum {
	PROMOTIONAL = TenantFeatureItemTypeEnum.PROMOTIONAL,

	VEHICLE_CATEGORY_STANDARD = VehicleCategoryFeatureItemTypeEnum.VEHICLE_CATEGORY_STANDARD,
	VEHICLE_CATEGORY_EXTRA = VehicleCategoryFeatureItemTypeEnum.VEHICLE_CATEGORY_EXTRA,

	VEHICLE_STANDARD = VehicleFeatureItemTypeEnum.VEHICLE_STANDARD,
	VEHICLE_EXTRA = VehicleFeatureItemTypeEnum.VEHICLE_EXTRA,
}
